import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { ShareListAPI } from '../features/shares/ShareListAPI';

export const store = configureStore({
  reducer: {
    [ShareListAPI.reducerPath]: ShareListAPI.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(ShareListAPI.middleware)
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
